import {TariffsController} from "../tariffs_controller";

export default class extends TariffsController {
  static targets = ["delete_link"]

  destroyTaxi(event) {
    event.preventDefault();
    let url = event.currentTarget.getAttribute("data-url");
    this._deleteService(url);
  }

  //
  // Private
  //
  _deleteService(url) {
    let confirmMessage = this.data.get("confirm-text");
    if (confirm(confirmMessage)) {
      Rails.ajax({
        url: url,
        type: 'delete',
        success: (data) => {
          if (data) {
            super._successNotify(data.notification_title, data.notification_message);
            window.location.reload();
          }
        },
        error: (data) => {
          if (data) {
            super._errorNotify(data.notification_title, data.notification_message);
          }
        }
      })
    }
  }
}